<template>
  <div class="Activity-Library">
    <div class="Activity-Library-header">
      <div class="clearfix"></div>
      <div class="container">
        <div class="row">
          <div :class="viewMode == false ? 'col-md-4 p-0' : 'col-md-4 p-0'">
            <div class="row">
              <div :class="viewMode == false ? 'col-md-5 p-0 align-self-center' : ''">
                <slot></slot>
              </div>
              <div id="datatable_filter" class="dataTables_search col-md-7 p-0">
                <input type="search" class="form-control form-control-sm" placeholder="Search" aria-controls="datatable" v-model="activitySearch" @change="enterSearchClicked()" />
              </div>
            </div>
          </div>
          <!--filter section-->
          <div class="main-filter-form col-md-5 p-0">
            <form class="filter-form">
              <label class="filter-label pl-5">Filters</label>
              <div class="row">
                <div class="col-lg-3 col-md-6 pl-5 pr-10">
                  <ActivityLibrarySelect :options="activityTypes" v-model="activityTypeFilter" @onChange="onChangeActivtyTypeFilter" field="type" title="Type" />
                </div>
                <div class="col-lg-3 col-md-6 p-0">
                  <ActivityLibrarySelect :options="therapeuticAreas" v-model="therapeuticAreasFilter" @onChange="onChangeTherapeuticAreasFilter" field="name" title="Therapeutic Area" />
                </div>
                <div class="col-lg-3 col-md-6 pl-10 pr-5">
                  <ActivityLibrarySelect :separatefirstchild="migrationDataValue && migrationDataValue.threadLibrary == false ? true : false" :options="createdBys" v-model="createdBysFilter" @onChange="onChangeCreatedBysFilter" field="name" title="Created By" />
                </div>
                <div class="col-lg-3 col-md-6 pl-10 pr-5">
                  <div class="multiselect filter-form-box" id="languageSelectBox" ref="languages-select">
                    <div id="select-Language" class="selectBox activity-type-select d-flex justify-content-between align-items-center truncate pl-5 pr-5" v-if="languagesFilter && languagesFilter.length">
                      <span class="d-inline-block truncate selected-filter" @click="showCheckboxesLanguage">{{ selectedLanguagesString }}</span>
                      <span class="d-inline-block clear-filter-contianer" @click="clearLanguageFilter">
                        <span class="clear-filter">x</span>
                      </span>
                    </div>
                    <div class="selectBox" v-else @click="showCheckboxesLanguage">
                      <select id="select-Language" class="activity-type-select">
                        <option value selected="selected">Language</option>
                      </select>
                      <div class="overSelect"></div>
                    </div>
                    <div id="showCheckboxesLanguage" class="select-scroll activity-builder-select-options" v-if="isDisplayLanguageCheckBoxes">
                      <input type="text" class="language-search-bar" placeholder="Enter a languange to filter" v-model="searchedLanguage" />
                      <div class="check_label_input d-flex" v-for="language in searchedLanguagesList" :key="language.language_id">
                        <input :id="language.language_id" @change="onChangeLanguageFilter(language)" type="checkbox" :checked="isLanguageSelected(language.language_id)" />
                        <label :for="language.language_id">{{ language.display_name }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="col-md-3 p-0" v-if="viewMode == false">
            <label class="filter-label">Organize</label>
            <div class="row">
              <div class="col-md-8 pl-0 pr-18">
                <ActivityLibrarySelect :options="organizeByOptions" v-model="organizeByFilter" @onChange="onChangeOrganizeByFilter" field="name" :title="selectedOrganizeByString" :singleSelection="true" />
              </div>
              <div class="col-md-4 p-0">
                <div class="filter-form-box dropleft">
                  <button type="button" class="btn settingsbutton submitBnt btn-default btn-block" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" @click="onClickSettings">
                    <img class="activity-library__settings-btn-img" src="static/img/activity-configurator/activity-table-settings.svg" aria-hidden="true" />
                    <span class="settings-text ml-5">Settings</span>
                  </button>
                  <div class="dropdown-menu settings-dropdown-menu p-0">
                    <span class="dropdown-item border-bottom settings-dropdown-item fs-12" @click="onClickExportActivity()">Export Activities List</span>
                    <router-link tag="a" :to="{ name: 'activity-library-archived-activities' }" class="dropdown-item border-bottom settings-dropdown-item fs-12">View Archive</router-link>
                    <router-link tag="a" :to="{ name: 'activity-library-manage-tags' }" class="dropdown-item border-bottom settings-dropdown-item fs-12" v-if="hideTagsOnPermission">Manage Tags</router-link>
                    <router-link tag="a" :to="{ name: 'activity-library-manage-groups' }" class="dropdown-item border-bottom settings-dropdown-item fs-12" v-if="hideTagsOnPermission">Manage Groups</router-link>
                    <span style="cursor: pointer" class="dropdown-item settings-dropdown-item fs-12" @click="onClickManageColumn()">Manage Columns</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal ref="exportActivitySuccessModal" :hide-header="true" :hide-footer="true" size="lg" :body-class="['p-0']" class="export-activity-success-modal" @hide="onModalClose" scrollable :no-close-on-backdrop="true">
      <img src="static/img/add.svg" class="rt-2-10 close-icon" @click="closeExportSuccessModal" />
      <div class="add-export-activity-modal__container pl-20 pt-25">
        <div class="Export-activity-list">
          <div class="manage-column-text">Export activity list</div>
          <div class="export-success-text">
            Your document is ready and should download automatically.
            <a :href="activityDownloadUrl">To download manually click here</a>
          </div>
          <img class="export-success-img" src="static/img/activity-configurator/green-check-large.png" />
        </div>
      </div>
    </b-modal>

    <b-modal ref="addExportActivityModal" :hide-header="true" :hide-footer="true" size="lg" :body-class="['p-0']" class="add-export-activity-modal" @hide="onModalClose" scrollable :no-close-on-backdrop="true">
      <img src="static/img/add.svg" class="rt-2-10 close-icon" @click="closeModal" />
      <div class="add-export-activity-modal__container pl-20 pt-25">
        <div class="Export-activity-list">
          <div class="manage-column-text">Export activity list</div>
          <div class="Select-an-export-option-below">
            Select an export option below
          </div>
          <div>
            <div class="export-activity-row pb-2">
              <input type="radio" v-model="exportFilterType" checked="checked" value="all" name="export_activity" class="export-radio" v-on:click="clearExportFields()" />
              <label class="export-radio-content">All created activities</label>
            </div>
            <div class="export-activity-row pb-2">
              <input type="radio" v-model="exportFilterType" value="studies" name="export_activity" class="export-radio" v-on:click="clearExportFields()" />
              <label class="export-radio-content">Activities added to a study</label>
            </div>
            <div class="export-activity-row pb-2">
              <input type="radio" v-model="exportFilterType" value="organization" name="export_activity" class="export-radio" v-on:click="clearExportFields()" />
              <label class="export-radio-content">Activities by group</label>
              <select class="export-type form-control d-inline-block" v-model="selectedOrganization" :disabled="exportFilterType != 'organization'">
                <option value="null" selected disabled>Select group</option>
                <option v-for="organization in organizations" :key="organization.groupId" :value="organization.groupId">
                  {{ organization.name }}
                </option>
              </select>
            </div>
            <div class="export-activity-row pb-2">
              <input type="radio" v-model="exportFilterType" value="created-by" name="export_activity" class="export-radio" v-on:click="clearExportFields()" />
              <label class="export-radio-content">Activities by creator</label>
              <select class="export-type form-control d-inline-block" v-model="selectedCreatedBy" :disabled="exportFilterType != 'created-by'">
                <option value="null" selected disabled>Select user</option>
                <option class="" v-for="createdBy in createdBys" :key="createdBy.id" :value="createdBy.id">
                  {{ createdBy.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="clearfix"></div>
          <div class="text-right">
            <button class="primary btn export-button" v-on:click="exportActivity()">
              Export activities
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal ref="addManageColumnModal" :hide-header="true" :hide-footer="true" size="lg" :body-class="['p-0']" class="add-manage-column-modal" @hide="onModalClose" scrollable :no-close-on-backdrop="true">
      <div class="add-manage-column-modal__container pl-20 pt-25">
        <div class="row">
          <div class="col-6 pr-0">
            <span class="manage-column-text">Manage Columns</span>
            <span class="fa fa-info-circle info-circle pl-10" aria-hidden="true" @click="toggleColumnInfo()" @blur="hideColumnInfo()" tabindex="-1"></span>

            <span class="info-circle-div" v-show="columnInfoDiv" style="width: 235px; height: 85px; margin-left: 25px">
              Tailor your organization's Activities column views by drag and drop sequencing and by enabling or disabling the view icon.
            </span>
          </div>
          <div class="col-6">
            <img src="static/img/add.svg" class="rt-2-10 manage-column-close" v-on:click="closeManageColumnModal" />
          </div>
        </div>
        <div>&nbsp;</div>
        <div class="row">
          <div class="Rectangle-15">
            <div class="row">
              <img src="static/img/activity-configurator/activities-list-view-1.png" class="activity-library-table__view-img1" />
              <b class="lft-5">Columns view 1</b>
            </div>
          </div>

          <div class="Rectangle-15">
            <div class="row">
              <img src="static/img/activity-configurator/activities-list-view-2.png" class="activity-library-table__view-img2" />
              <b class="lft-5">Columns view 2</b>
            </div>
          </div>

          <div class="Rectangle-16">
            <div class="Rectangle-17 rt-45">Activity Name</div>
            <draggable v-model="firstColumnNames" @start="drag = true" @end="drag = false">
              <div v-for="(firstColumnName, index) in firstColumnNames" :key="index">
                <div class="Rectangle-17" v-if="migrationData && migrationData.threadLibrary && migrationData.activityMigration">
                  <img src="static/img/drag.svg" alt class="pad-10 cursor_pointer reorder-icon" />
                  {{ findColumnName(firstColumnName) }}
                  <img :src="isColumnExists(firstColumnName, 1)" v-on:click="toggleColumn(firstColumnName, 1)" alt class="rt-10" />
                </div>
                <div class="Rectangle-17" v-else-if="findColumnName(firstColumnName) != 'Version' && findColumnName(firstColumnName) != 'Instances'">
                  <img src="static/img/drag.svg" alt class="pad-10 cursor_pointer reorder-icon" />
                  {{ findColumnName(firstColumnName) }}
                  <img :src="isColumnExists(firstColumnName, 1)" v-on:click="toggleColumn(firstColumnName, 1)" alt class="rt-10" />
                </div>
              </div>
            </draggable>
          </div>

          <div class="row">&nbsp;&nbsp;&nbsp;&nbsp;</div>

          <div class="Rectangle-16">
            <div class="Rectangle-17 rt-45">Activity Name</div>
            <draggable v-model="secondColumnNames" @start="drag = true" @end="drag = false">
              <div v-for="(secondColumnName, index) in secondColumnNames" :key="index">
                <div class="Rectangle-17" v-if="migrationData && migrationData.threadLibrary && migrationData.activityMigration">
                  <img src="static/img/drag.svg" alt class="pad-10 cursor_pointer reorder-icon" />
                  {{ findColumnName(secondColumnName) }}
                  <img :src="isColumnExists(secondColumnName, 2)" v-on:click="toggleColumn(secondColumnName, 2)" alt class="rt-10" />
                </div>
                <div class="Rectangle-17" v-else-if="findColumnName(secondColumnName) != 'Version' && findColumnName(secondColumnName) != 'Instances'">
                  <img src="static/img/drag.svg" alt class="pad-10 cursor_pointer reorder-icon" />
                  {{ findColumnName(secondColumnName) }}
                  <img :src="isColumnExists(secondColumnName, 2)" v-on:click="toggleColumn(secondColumnName, 2)" alt class="rt-10" />
                </div>
              </div>
            </draggable>
          </div>
        </div>

        <button class="add-manage-column-btn btn" v-on:click="saveColumns()">
          Save
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ActivityLibrarySelect from "./activity-library-select";
import * as ALL_COLUMN_NAMES from "@/constants/activity-library-and-configurator-component/column-names";
import draggable from "vuedraggable";
import toastr from "toastr";
import _ from "lodash";

const defaultView1 = [ALL_COLUMN_NAMES.NAME, ALL_COLUMN_NAMES.TYPE, ALL_COLUMN_NAMES.THERAPUETIC_AREA, ALL_COLUMN_NAMES.CREATED_BY, ALL_COLUMN_NAMES.GROUP, ALL_COLUMN_NAMES.STEPS, ALL_COLUMN_NAMES.DURATION, ALL_COLUMN_NAMES.LANGUAGE, ALL_COLUMN_NAMES.LAST_MODIFIED];
const defaultView2 = [ALL_COLUMN_NAMES.NAME, ALL_COLUMN_NAMES.TYPE, ALL_COLUMN_NAMES.THERAPUETIC_AREA, ALL_COLUMN_NAMES.TAGS, ALL_COLUMN_NAMES.VERSION, ALL_COLUMN_NAMES.INSTANCES, ALL_COLUMN_NAMES.GROUP, ALL_COLUMN_NAMES.STUDIES, ALL_COLUMN_NAMES.STEPS, ALL_COLUMN_NAMES.DURATION, ALL_COLUMN_NAMES.LANGUAGE];

export default {
  name: "activity-library",
  components: {
    ActivityLibrarySelect,
    draggable
  },
  data() {
    return {
      exportFilterType: "all",
      activitySearch: "",
      therapeuticAreas: [],
      createdBys: [],
      organizations: [],
      activityTypes: [],
      activityTypeFilter: [],
      therapeuticAreasFilter: [],
      organizeByFilter: 0,
      createdBysFilter: [],
      languageFilter: [],
      languages: [],
      languagesFilter: [],
      organizeByOptions: [
        { name: "All Activities", value: "", id: 0 },
        { name: "Group", value: "group_name", id: 1 },
        { name: "Created By", value: "created_by", id: 2 },
        { name: "Tags", value: "tags", id: 3 }
      ],
      activityDownloadUrl: null,
      searchedLanguage: "",
      isDisplayLanguageCheckBoxes: false,
      eventListenerToHideLanguageDropdown: null,
      selectedCreatedBy: null,
      selectedOrganization: null,
      selectedOrganizeByString: "All Activities",
      allColumnNames: [
        ALL_COLUMN_NAMES.TYPE,
        ALL_COLUMN_NAMES.THERAPUETIC_AREA,
        ALL_COLUMN_NAMES.OBJECTIVE,
        ALL_COLUMN_NAMES.TAGS,
        ALL_COLUMN_NAMES.STUDIES,
        ALL_COLUMN_NAMES.GROUP,
        ALL_COLUMN_NAMES.CREATED_BY,
        ALL_COLUMN_NAMES.STEPS,
        ALL_COLUMN_NAMES.VERSION,
        ALL_COLUMN_NAMES.INSTANCES,
        ALL_COLUMN_NAMES.DURATION,
        ALL_COLUMN_NAMES.LANGUAGE,
        ALL_COLUMN_NAMES.LAST_MODIFIED,
        ALL_COLUMN_NAMES.ABBREVIATION
      ],
      displayColumnNames: {
        [ALL_COLUMN_NAMES.TYPE]: "Type",
        [ALL_COLUMN_NAMES.THERAPUETIC_AREA]: "Therapeutic Area",
        [ALL_COLUMN_NAMES.OBJECTIVE]: "Objective",
        [ALL_COLUMN_NAMES.TAGS]: "Tags",
        [ALL_COLUMN_NAMES.STUDIES]: "Studies",
        [ALL_COLUMN_NAMES.GROUP]: "Group",
        [ALL_COLUMN_NAMES.CREATED_BY]: "Created By",
        [ALL_COLUMN_NAMES.STEPS]: "Steps",
        [ALL_COLUMN_NAMES.VERSION]: "Version",
        [ALL_COLUMN_NAMES.INSTANCES]: "Instances",
        [ALL_COLUMN_NAMES.DURATION]: "Duration",
        [ALL_COLUMN_NAMES.LANGUAGE]: "Language",
        [ALL_COLUMN_NAMES.LAST_MODIFIED]: "Last Modified",
        [ALL_COLUMN_NAMES.ABBREVIATION]: "Abbreviation"
      },
      columnViews: null,
      firstColumnNames: [],
      secondColumnNames: [],
      defaultView1,
      defaultView2,
      VIEW_1: 1,
      VIEW_2: 2,
      isViewEmpty: null,
      columnInfoDiv: false,
      autoSaveElementTimeout: process.env.VUE_APP_AUTO_SAVE_ELEMENT_LIB_TIMEOUT,
      migrationDataValue: this.migrationData
    };
  },
  props: {
    allFilterTypes: {},
    _views: {},
    viewMode: { type: Boolean, default: false },
    migrationData: { type: Object }
  },
  mounted() {
    this.hideLanguageCheckBox();
  },
  watch: {
    _views() {
      this.views = _.cloneDeep(this._views);
    },
    "migrationData.threadLibrary"(newVal) {
      this.migrationDataValue.threadLibrary = newVal;
      this.getCreatedBys();
    }
  },
  computed: {
    hideTagsOnPermission() {
      const userData = this.$store.state.user.user;
      const valueToCheck = this.$store.state.user.user.activityLibraryAllowed;
      if (userData.userRole === "StudyAdmin" && valueToCheck != undefined) {
        return valueToCheck;
      } else {
        return true;
      }
    },

    searchedLanguagesList() {
      if (!this.languages) {
        return [];
      }
      if (!this.languages.length) {
        return [];
      }

      const languages = this.languages.filter(language => language.display_name.toLowerCase().includes(this.searchedLanguage.toLowerCase()));
      return _.sortBy(languages, "name");
    },
    selectedLanguagesString() {
      if (this.languagesFilter && this.languagesFilter.length) {
        if (this.languagesFilter.length === 1) {
          return this.languagesFilter[0].display_name || this.languagesFilter[0].languageName;
        }
        const selectedValuesString = `Languages ${this.languagesFilter.length}`;
        return selectedValuesString;
      }
      return "";
    }
  },
  methods: {
    closeModal() {
      this.$refs.addExportActivityModal.hide();
    },
    closeExportSuccessModal() {
      this.$refs.exportActivitySuccessModal.hide();
    },
    toggleColumnInfo() {
      if (this.columnInfoDiv) {
        this.hideColumnInfo();
      } else {
        this.showColumnInfo();
      }
    },
    hideColumnInfo() {
      this.columnInfoDiv = false;
      this.$el.blur();
    },
    showColumnInfo() {
      this.columnInfoDiv = true;
      this.$el.focus();
    },
    exportActivity() {
      this.$refs.addExportActivityModal.hide();
      let val;
      if (this.exportFilterType == "organization") {
        val = this.selectedOrganization;
        if (this.selectedOrganization == undefined || this.selectedOrganization.length == 0) {
          this.$toastr.error("Group is required.");
          return;
        }
      } else if (this.exportFilterType == "created-by") {
        val = this.selectedCreatedBy;
        if (this.selectedCreatedBy == undefined || this.selectedCreatedBy.length == 0) {
          this.$toastr.error("User is required.");
          return;
        }
      }
      this.$api
        .exportActivity(this.exportFilterType, val)
        .then(response => {
          if (response && response.data.status == "Success") {
            this.activityDownloadUrl = response.data.result;
            this.$refs.exportActivitySuccessModal.show();
          } else {
            this.$toastr.error("Error exporting activities -" + response.data.message);
          }
        })
        .catch(error => {
          if (error.body && error.body.message) {
            this.$toastr.error(error.body.message);
          } else {
            this.$toastr.error("Error while exporting activities");
          }
        });
    },
    findColumnName(columnName) {
      if (columnName.split("#")[0] == ALL_COLUMN_NAMES.NAME) {
        return;
      }
      return this.displayColumnNames[columnName.split("#")[0]];
    },
    closeManageColumnModal() {
      this.$refs.addManageColumnModal.hide();
      this.stopAutoSave();
    },
    saveColumns(autoSave = false) {
      if (this.isViewEmpty) {
        this.$refs.addManageColumnModal.hide();
        this.stopAutoSave();
        const body = [{}, {}];

        this.firstColumnNames.unshift(ALL_COLUMN_NAMES.NAME + "#1");
        this.secondColumnNames.unshift(ALL_COLUMN_NAMES.NAME + "#1");

        body[0].cols = this.firstColumnNames.join(",");
        body[1].cols = this.secondColumnNames.join(",");

        this.$api
          .postActivityViews(body)
          .then(() => {
            this.firstColumnNames.splice(0, 1);
            this.secondColumnNames.splice(0, 1);

            if (!autoSave) {
              this.$toastr.success("Columns saved successfully");
            }
            this.$emit("updateColumns");
            this.getActivityViews();
          })
          .catch(() => {
            if (!autoSave) {
              this.$toastr.error("Unable to add columns");
            }
          });
      } else {
        this.$refs.addManageColumnModal.hide();
        this.stopAutoSave();
        const body = [{}, {}];

        if (this.firstColumnNames.indexOf(ALL_COLUMN_NAMES.NAME + "#1") == -1) {
          this.firstColumnNames.unshift(ALL_COLUMN_NAMES.NAME + "#1");
          body[0].cols = this.firstColumnNames.join(",");
        } else {
          body[0].cols = this.firstColumnNames.join(",");
        }

        if (this.secondColumnNames.indexOf(ALL_COLUMN_NAMES.NAME + "#1") == -1) {
          this.secondColumnNames.unshift(ALL_COLUMN_NAMES.NAME + "#1");
          body[1].cols = this.secondColumnNames.join(",");
        } else {
          body[1].cols = this.secondColumnNames.join(",");
        }

        body[0].view_id = this.columnViews[1].view_id;
        body[1].view_id = this.columnViews[2].view_id;

        this.$api
          .modifyActivityViews(body)
          .then(() => {
            this.firstColumnNames.splice(0, 1);
            this.secondColumnNames.splice(0, 1);

            if (!autoSave) {
              this.$toastr.success("Columns updated successfully");
            }
            this.$emit("updateColumns");
            this.getActivityViews();
          })
          .catch(() => {
            if (!autoSave) {
              this.$toastr.error("Unable to update columns");
            }
          });
      }
    },
    toggleColumn(columnName, viewScreen) {
      const actualColumnValue = columnName.split("#");
      let newColumnValue = 0;
      if (actualColumnValue[1] == 0) {
        newColumnValue = 1;
      } else {
        newColumnValue = 0;
      }

      if (viewScreen == 1) {
        const columnNameIndex = this.firstColumnNames.indexOf(columnName);
        this.firstColumnNames[columnNameIndex] = actualColumnValue[0] + "#" + newColumnValue;
        this.$forceUpdate();
      } else if (viewScreen == 2) {
        const columnNameIndex = this.secondColumnNames.indexOf(columnName);
        this.secondColumnNames[columnNameIndex] = actualColumnValue[0] + "#" + newColumnValue;
        this.$forceUpdate();
      }
    },
    isColumnExists(columnName, viewScreen) {
      if (!this.columnViews || this.columnViews == {}) {
        return;
      }

      const actualColumnName = columnName.split("#");
      if (actualColumnName[0] == ALL_COLUMN_NAMES.NAME) {
        return;
      }

      if (viewScreen == 1) {
        if (actualColumnName[1] == 1) {
          return "static/img/activity-configurator/view-OPT.png";
        } else {
          return "static/img/activity-configurator/group.png";
        }
      } else if (viewScreen == 2) {
        if (actualColumnName[1] == 1) {
          return "static/img/activity-configurator/view-OPT.png";
        } else {
          return "static/img/activity-configurator/group.png";
        }
      }
    },
    async onClickManageColumn() {
      await this.getActivityViews();
      this.$refs.addManageColumnModal.show();
      this.startAutoSave();
    },
    onClickExportActivity() {
      this.$refs.addExportActivityModal.show();
      this.exportFilterType = "all";
      this.selectedCreatedBy = null;
      this.selectedOrganization = null;
    },
    clearExportFields() {
      this.$nextTick(() => {
        if (this.exportFilterType == "all" || this.exportFilterType == "studies") {
          this.selectedCreatedBy = null;
          this.selectedOrganization = null;
        } else if (this.exportFilterType == "organization") {
          this.selectedCreatedBy = null;
        } else if (this.exportFilterType == "created-by") {
          this.selectedOrganization = null;
        }
      });
    },
    enterSearchClicked() {
      this.$emit("activitySearch", this.activitySearch);
    },

    showCheckboxesLanguage() {
      if (!this.isDisplayLanguageCheckBoxes) {
        this.isDisplayLanguageCheckBoxes = true;
      } else {
        this.isDisplayLanguageCheckBoxes = false;
      }
    },
    onModalClose() {},
    onClickSettings() {},
    onChangeTherapeuticAreasFilter() {
      const filterType = this.allFilterTypes["AREA"];
      const ids = this.therapeuticAreasFilter.map(area => area.id);
      const filterObj = { [filterType]: ids.join(",") };
      this.$emit("filterChanged", filterObj);
    },
    onChangeCreatedBysFilter() {
      const filterType = this.allFilterTypes["CREATEDBY"];
      const ids = this.createdBysFilter.map(area => area.id);
      const filterObj = { [filterType]: ids.join(",") };
      this.$emit("filterChanged", filterObj);
    },
    onChangeActivtyTypeFilter() {
      const filterType = this.allFilterTypes["TYPE"];
      const ids = this.activityTypeFilter.map(area => area.id);
      const filterObj = { [filterType]: ids.join(",") };
      this.$emit("filterChanged", filterObj);
    },

    onChangeOrganizeByFilter() {
      const organizeByOption = this.organizeByOptions.find(val => val.id === this.organizeByFilter);
      if (organizeByOption) {
        this.selectedOrganizeByString = organizeByOption.name;
        this.$emit("onOrganizeByChange", organizeByOption.value);
      }
    },

    onChangeLanguageFilter(language) {
      const optionIndex = this.languagesFilter.findIndex(element => element.language_id === language.language_id);

      if (optionIndex === -1) {
        this.languagesFilter.push(language);
      } else {
        this.languagesFilter.splice(optionIndex, 1);
      }

      const filterType = this.allFilterTypes["LANGUAGES"];
      const ids = this.languagesFilter.map(l => l.language_id);
      const filterObj = { [filterType]: ids.join(",") };
      this.$emit("filterChanged", filterObj);
    },

    hideLanguageCheckBox() {
      this.eventListenerToHideLanguageDropdown = document.addEventListener("click", event => {
        if (this.$refs["languages-select"] && this.$refs["languages-select"].contains(event.target)) {
        } else {
          this.isDisplayLanguageCheckBoxes = false;
          this.searchedLanguage = "";
        }
      });
    },

    isLanguageSelected(id) {
      return this.languagesFilter.findIndex(e => e.language_id === id) > -1;
    },

    onChangeFilter(filter) {
      const filterObj = { type: filter.join(",") };
      this.$emit("filterChanged", filterObj);
    },

    clearLanguageFilter() {
      this.languagesFilter = [];
      const filterType = this.allFilterTypes["LANGUAGES"];
      const filterObj = { [filterType]: "" };
      this.$emit("filterChanged", filterObj);
    },

    // API CALLS

    getTherapeuticAreas() {
      this.$api
        .getTherapeuticAreas()
        .then(response => {
          this.therapeuticAreas = response.data.result;
        })
        .catch(() => {
          this.$toastr.error("Error in getting Therapeutic Areas");
        });
    },

    getCreatedBys() {
      this.$api
        .getCreatedBys()
        .then(response => {
          this.createdBys = [];
          if (this.migrationDataValue && this.migrationDataValue.threadLibrary == false) {
            this.createdBys.push({ id: "THREAD", name: "THREAD" });
          }
          for (let i = 0; i < response.data.result.length; i++) {
            this.createdBys.push(response.data.result[i]);
          }
        })
        .catch(() => {
          this.$toastr.error("Error in getting Created users list");
        });
    },

    getOrganizations() {
      this.$api
        .getOrganizations()
        .then(response => {
          this.organizations = response.data.result;
        })
        .catch(() => {
          this.$toastr.error("Error in getting Organizations list");
        });
    },

    getActivityTypes() {
      this.$api
        .getActivityTypes()
        .then(response => {
          this.activityTypes = response.data.result;
        })
        .catch(() => {
          this.$toastr.error("Error in getting Therapeutic Areas");
        });
    },

    getLanguages() {
      this.$api.getSupportedClientLanguages().then(
        response => {
          if (response.body.length == 0) {
            return;
          }
          this.languages = response.body;
        },
        () => {
          toastr.error("Error occurred while featching languages.");
        }
      );
    },
    setDefaultViews() {
      this.columnViews = {};
      this.columnViews[this.VIEW_1] = {};
      this.columnViews[this.VIEW_2] = {};

      this.columnViews[this.VIEW_1].cols = this.defaultView1;
      this.columnViews[this.VIEW_2].cols = this.defaultView2;

      this.firstColumnNames = [];
      this.secondColumnNames = [];

      _.forEach(this.allColumnNames, allColumnName => {
        const columnNameIndex1 = this.columnViews[this.VIEW_1].cols.indexOf(allColumnName);
        const columnNameIndex2 = this.columnViews[this.VIEW_2].cols.indexOf(allColumnName);
        if (columnNameIndex1 != -1) {
          if (this.firstColumnNames.indexOf(allColumnName + "#1") == -1) {
            this.firstColumnNames.push(allColumnName + "#1");
          }
        } else {
          if (this.firstColumnNames.indexOf(allColumnName + "#0") == -1) {
            this.firstColumnNames.push(allColumnName + "#0");
          }
        }
        if (columnNameIndex2 != -1) {
          if (this.secondColumnNames.indexOf(allColumnName + "#1") == -1) {
            this.secondColumnNames.push(allColumnName + "#1");
          }
        } else {
          if (this.secondColumnNames.indexOf(allColumnName + "#0") == -1) {
            this.secondColumnNames.push(allColumnName + "#0");
          }
        }
        // }
      });
    },
    getActivityViews() {
      this.$api
        .getActivityViews()
        .then(response => {
          const columnViews = response.body.result || [];
          if (columnViews.length) {
            this.isViewEmpty = false;
            this.columnViews = {};
            this.columnViews[1] = {};
            this.columnViews[2] = {};

            this.firstColumnNames = columnViews[0].cols.split(",");
            this.secondColumnNames = columnViews[1].cols.split(",");

            this.firstColumnNames.splice(0, 1);
            this.secondColumnNames.splice(0, 1);

            const firstColumnObj = {};

            this.firstColumnNames.forEach(column => {
              const columnName = column.split("#")[0];
              firstColumnObj[columnName] = true;
            });

            const secondColumnObj = {};

            this.firstColumnNames.forEach(column => {
              const columnName = column.split("#")[0];
              secondColumnObj[columnName] = true;
            });

            this.allColumnNames.forEach(column => {
              if (!firstColumnObj[column]) {
                this.firstColumnNames.push(column + "#0");
              }
              if (!secondColumnObj[column]) {
                this.secondColumnNames.push(column + "#0");
              }
            });

            this.columnViews[1].view_id = columnViews[0].id;
            this.columnViews[2].view_id = columnViews[1].id;
          } else {
            this.isViewEmpty = true;
            this.setDefaultViews();
          }
        })
        .catch(() => {
          this.$toastr.error("Failed to get activity views. Setting default views for now");
          this.setDefaultViews();
        });
    },
    startAutoSave() {
      this.autoSaveTimer = setInterval(() => {
        this.saveColumns(true);
      }, this.autoSaveElementTimeout);
    },
    stopAutoSave() {
      clearInterval(this.autoSaveTimer);
    }
  },
  beforeDestroy() {
    this.stopAutoSave();
  },
  created() {
    this.getActivityTypes();
    this.getTherapeuticAreas();
    this.getCreatedBys();
    this.getLanguages();
    this.getActivityViews();
    this.getOrganizations();
  },

  destroyed() {
    document.removeEventListener("click", this.eventListenerToHideLanguageDropdown);
  }
};
</script>

<style scoped lang="scss">
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}
.card {
  border: none;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
}

.Activity-Library-header {
  width: 100%;
  height: 85px;
  background: rgb(176, 186, 201);
  background: linear-gradient(180deg, rgb(193, 202, 213) 50%, rgba(211, 233, 288, 0.5) 100%);
  margin-top: 70px;
  padding-top: 35px;

  .container {
    max-width: 90%;
  }
}
.Activity-Library-header .btn {
  font-size: 14px;
}
.Activity-Library-header .create_activity .btn {
  font-size: 14px;
  padding: 2px 5px 2px 2px;
  height: 35px;
  width: 100%;
}
#select-Language {
  width: 88%;
}
.settingsbutton.submitBnt {
  color: #fff;
  background-color: #b0bac9;
  padding: 2px;
  height: 35px;
}
.settingsbutton.submitBnt .fa.fa-cog {
  font-size: 22px;
  line-height: 20px;
  vertical-align: bottom;
}
.create_activity .btn img {
  width: 26px;
  margin-right: 8px;
  border-radius: 3px;
  right: 11px;
  position: relative;
}
.create_activity .btn {
  background-color: #4c8ce4;
}
.create_activity .text {
  font-size: 14px;
  line-height: 0.43;
  color: #ffffff;
  position: relative;
  top: 2px;
  right: 9px;
}
table.dataTable.nowrap th {
  font-size: 11px;
  color: #b0bac9;
  border-bottom: 1px solid #b0bac9;
  border-top: none;
  padding: 10px 38px 10px 10px;
}
table.dataTable.nowrap td {
  font-size: 12px;
  padding: 10px 15px 10px 10px;
  color: #000;
}
table.dataTable.nowrap td.name {
  font-size: 13px;
  color: #4c8ce4;
  font-weight: bold;
}
table.dataTable.nowrap td.type {
  font-weight: bold;
}
table.dataTable.nowrap td input {
  line-height: 1.66;
  height: 30px;
  border-radius: 12px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.06);
  border: solid 1px #e8e8e8;
  background-color: #ffffff;
  padding-left: 10px;
  width: 50%;
}
table.dataTable.nowrap td.languages-box {
  padding: 5px 10px;
}
.dataTables_search input {
  width: 96%;
  height: 36px;
  background-image: url(/static/img/activity-configurator/activity-library-search.svg) !important;
  background-position: right 2% top 80% !important;
  background-repeat: no-repeat;
  background-size: 26px 27px;
  border-radius: 0.2rem;
}
.create_activity {
  width: 91%;
}
.main-filter-form {
  font-size: 12px;
}
.filter-label {
  position: absolute;
  top: -20px;
  color: #2d3652;
  font-size: 12px;
}
.filter-form-box .activity-type-select {
  width: 100%;
  font-size: 12px;
  border: none;
  height: 35px;
  border-radius: 3px;
  background-color: #ffff;
  color: #666669;
}
#select-Therapeutic {
  width: 130px;
}
.header-title {
  font-size: 16px;
  color: #000000;
}
.card-body {
  padding: 15px;
}

.selectBox {
  position: relative;
}

.selectBox select {
  width: 100%;
}

.overSelect {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

#checkboxes {
  background: #fff;
  position: absolute;
  width: 316px;
  border-radius: 3px;
  padding: 10px;
  z-index: 1;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  overflow: scroll;
  height: 469px;
}

#checkboxes label {
  font-size: 14px;
  color: #000;
  margin-left: 8px;
  float: left;
  width: 275px;
  line-height: 30px;
}
.filter-form-box .select-scroll::-webkit-scrollbar {
  width: 8px; /* width of the entire scrollbar */
}
.filter-form-box .select-scroll::-webkit-scrollbar-track {
  background: transparent; /* color of the tracking area */
}
.filter-form-box .select-scroll::-webkit-scrollbar-thumb {
  background-color: #b0bac9; /* color of the scroll thumb */
  border-radius: 20px; /* roundness of the scroll thumb */
  border: 3px solid transparent; /* creates padding around scroll thumb */
}
.select-scroll {
  scrollbar-width: thin; /* "auto" or "thin"  */
  scrollbar-color: #e6e9ed transparent; /* scroll thumb & track */
}

#TypeCheckboxes {
  /* display: none; */
  background: #fff;
  position: absolute;
  width: 316px;
  border-radius: 3px;
  padding: 10px;
  z-index: 1;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  overflow: scroll;
  height: 469px;
}

#TypeCheckboxes label {
  font-size: 14px;
  color: #000;
  margin-left: 8px;
  float: left;
  width: 275px;
  line-height: 30px;
}

#showCheckboxesCreate {
  /* display: none; */
  background: #fff;
  position: absolute;
  width: 142px;
  border-radius: 3px;
  padding: 10px;
  z-index: 1;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}

#showCheckboxesCreate label {
  font-size: 14px;
  color: #000;
  margin-left: 8px;
  float: left;
  width: 275px;
  line-height: 30px;
}

#showCheckboxesLanguage {
  /* display: none; */
  background: #fff;
  position: absolute;
  width: 204.5px;
  height: 301px;
  border-radius: 3px;
  padding: 10px;
  z-index: 3;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}

#showCheckboxesOrganizeby label {
  font-size: 14px;
  color: #000;
  margin-left: 8px;
  float: left;
  width: 275px;
  line-height: 30px;
}

#showCheckboxesOrganizeby {
  /* display: none; */
  background: #fff;
  position: absolute;
  width: 147px;
  height: 165px;
  border-radius: 3px;
  padding: 10px;
  z-index: 1;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);

  .organize-by-select-item {
    border-bottom: 1px solid #dddddd;
  }
}

#showCheckboxesLanguage label {
  font-size: 14px;
  color: #000;
  margin-left: 8px;
  float: left;
  width: 275px;
  line-height: 30px;
  white-space: nowrap;
  margin-bottom: 0;
}
.check_label_input input {
  float: left;
  line-height: 30px;
  margin-top: 0px;
  -webkit-margin-before: 8px;
}
.width-100p {
  width: 100px !important;
}
#showCheckboxesCreate .check_label_input:first-child {
  border-bottom: 2px solid #eee;
}
.language-search-bar {
  width: 181px;
  height: 33px;
  border-radius: 4px;
  border: solid 1px #b0bac9;
  background-color: #ffffff;
}
.dataTables_search {
  margin-left: -1%;
}

.activity-builder-select-options {
  overflow: scroll;
  top: 0;
}
@media screen and (min-device-width: 1024px) and (max-device-width: 1269px) {
  .create_activity .btn img {
    display: none;
  }

  .create_activity .text {
    font-size: 85%;
  }
}

.settings-dropdown-item {
  line-height: 27px;
  font-size: 12px;
  padding: 0.125rem 0.75rem;
  cursor: pointer;
}

.settings-dropdown-menu {
  min-width: 8rem;
}

.activity-library {
  &__settings-btn-img {
    position: relative;
    top: -1px;
  }
}

.manage-column-text {
  height: 26px;
  font-family: "RobotoRegular";
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #000000;
}

.add-export-activity-modal {
  .modal-dialog {
    vertical-align: top !important;
    top: 100px;
  }

  &__container {
    width: 404px;
    height: 336px;
    border-radius: 4px;
    background-color: #ffffff;

    .fw-bold {
      font-weight: bold;
    }

    .color-black {
      color: black;
    }
  }
}

.add-manage-column-modal {
  .modal-dialog {
    vertical-align: top !important;
    top: 100px;
  }

  &__container {
    width: 566px;
    height: 687px;
    border-radius: 3px;
    background-color: #ffffff;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);

    .fw-bold {
      font-weight: bold;
    }

    .color-black {
      color: black;
    }
  }
}

.Rectangle-15 {
  width: 240px;
  height: 30px;
  background-color: #ffffff;
  margin-left: 15px;
}

.Rectangle-16 {
  width: 255px;
  height: auto;
  border-radius: 4px;
  border: solid 1px #d3dee3;
  background-color: #ffffff;
}
.Rectangle-17 {
  width: 233px;
  height: 29px;
  padding-left: 6px;
  padding-top: 6px;
  margin-left: 10px;
  margin-top: 5px;
  border-radius: 4px;
  color: #000000;
  background-color: rgba(197, 209, 214, 0.5);
}

.pad-10 {
  padding: 0px 10px 0px 10px;
}
.rt-10 {
  float: right;
  padding: 2px 10px 0px 10px;
}

.rt-50 {
  padding-left: 50px;
}

.rt-2-10 {
  float: right;
  padding: 0px 10px 0px 10px;
}

.add-manage-column-btn {
  width: 116px;
  height: 35px;
  border-radius: 4px;
  background-color: #4c8ce4;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #ffffff;
  margin: 20px 20px;
  float: right;
}

.Rectangle-437 {
  width: 44px;
  height: 27px;
  border-radius: 3px;
  border: solid 1px #b0bac9;
  background-color: #f5f8fa;
}

.Rectangle-451 {
  width: 6px;
  height: 11px;
  border-radius: 1px;
  background-color: #d3dee3;
}

.lft-5 {
  margin-left: 5px;
}

.activity-library-table {
  &__container {
    margin: 0 auto;

    .card-body {
      padding: 0;
    }

    .container {
      max-width: 90%;
    }

    .card {
      border: none;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
    }
  }

  &__view-img1 {
    /* width: 44px; */
    height: 34px;
    cursor: pointer;
    margin-top: -8px;
    margin-left: -18px;
  }
  &__view-img2 {
    /* width: 44px; */
    height: 34px;
    cursor: pointer;
    margin-top: -8px;
    margin-left: -3px;
  }
}

.manage-column-close {
  cursor: pointer;
  top: -20px;
  position: absolute;
  right: 0px;
}

.selected-filter {
  color: #4c8ce4;
  width: 80%;
  cursor: pointer;
}

.clear-filter-contianer {
  width: 20%;
}

.clear-filter {
  width: 14px;
  height: 14px;
  background-color: #4c8ce4;
  color: #ffffff;
  border-radius: 7px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  line-height: 12px;
}

.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(90%);
}

.Export-activity-list {
  font-family: RobotoRegular;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #000000;
}

.Select-an-export-option-below {
  width: 333px;
  height: 42px;
  font-family: RobotoRegular;
  font-size: 14px;
  /*font-weight: normal;*/
  font-stretch: normal;
  font-style: normal;
  line-height: 2.71;
  letter-spacing: normal;
  color: #000000;
}

.export-radio {
  width: 20px;
  height: 20px;
  background-color: #4c8ce4;
  top: 5px;
  position: relative;
}

.export-radio-content {
  width: 195px;
  height: 20px;
  opacity: 0.7;
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #666669;
  margin-left: 10px;
}

.export-activity-row {
  margin-left: 0;
  margin-right: 0;
  width: 360px;
  line-height: 36px;
}

.export-type {
  width: 120px;
  height: 35px;
  border-radius: 3px;
  border: solid 1px #d3dfe4;
  padding: 0px 10px;
}

.export-button {
  width: 136px;
  height: 35px;
  border-radius: 4px;
  background-color: #4c8ce4;
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #ffffff;
  margin: 20px 20px;
  float: right;
}

.export-success-text {
  width: 350px;
  height: 105px;
  font-family: RobotoRegular;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #666669;
  margin-top: 10px;
}

.export-success-img {
  margin-left: 120px;
}
.configure-form {
  background-color: #4c8ce4;
  border: solid 2px #4c8ce4;
  color: #ffffff;
  cursor: pointer;
}

.info-circle-div {
  width: 280px;
  height: 80px;
  background-color: #ffffff;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #666669;
  padding: 13px 16px 19px 13px;
  position: absolute;
  border-radius: 3px;
  margin-left: 510px;
  margin-top: -25px;
  box-shadow: 1px 1px #d3deef;
}
.close-icon {
  position: absolute;
  right: 0px;
  top: 8px;
  cursor: pointer;
}
.create_activity .btn .list_icon {
  width: 26px;
  margin-right: 8px;
  border-radius: 3px;
  right: 11px;
  position: relative;
}
</style>
